import { Partner } from '../types';

/**
 * Whether a partner should appear in a funeral's partner dropdowns.
 * Partners with no region set are shown everywhere (safe default for rows
 * created before regions existed); a funeral with no region sees everyone.
 */
export const partnerMatchesRegion = (
  partner: Partner,
  funeralRegion: string | null | undefined,
): boolean => !partner.region || !funeralRegion || partner.region === funeralRegion;
